var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"abs full"},[_c('keep-alive',[(_vm.scenario !== 'globe')?_c('Map2D',[_vm._l((_vm.components),function(comp,i){return _c(comp,{key:i,tag:"component"})}),_c('ztdt'),_c('timeLine')],2):_vm._e(),_c('Scenario')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }